// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Z_ooH","box":"styles_box__mf8dd","icon":"styles_icon__QhSxI"};